// numericInput
// ------------
// Browsers let "e"/"E" (scientific-notation exponent) and "+"/"-" be typed into
// <input type="number">, so price/cost fields silently accept e.g. "1e5" or "-3".
// Other letters are rejected by the browser, which is why only e/E/+/- slip
// through. This installs ONE global keydown guard that blocks those characters on
// any number input — covering every price field (request wizard, edit path,
// Standard Costs admin) and any added later. "." and digits are untouched.

const BLOCKED_KEYS = new Set(["e", "E", "+", "-"]);

export function blockExponentKeys(e: KeyboardEvent): void {
  const target = e.target as HTMLElement | null;
  if (target instanceof HTMLInputElement && target.type === "number" && BLOCKED_KEYS.has(e.key)) {
    e.preventDefault();
  }
}

// Registers the guard on the given document (defaults to the global one) and
// returns a cleanup function (so a React effect can remove it on unmount).
export function installNumericInputGuard(doc: Document = document): () => void {
  doc.addEventListener("keydown", blockExponentKeys);
  return function () {
    doc.removeEventListener("keydown", blockExponentKeys);
  };
}
